/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaBenchPlayerCreate = {
    properties: {
        playerId: {
            type: 'number',
            isRequired: true,
        },
        order: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
